import React, { useState } from "react";
import { useLicense } from "../../hooks/useLicense";
import api from "../../services/api";
import { toast } from "react-toastify";

export default function UserAccessCell({ user, onChanged }) {
  const { companyHasOctopushX, companyHasRecordingStudio } = useLicense();
  const [saving, setSaving] = useState(false);
  const [x, setX] = useState(!!user.hasOctopushXAccess);
  const [rs, setRs] = useState(!!user.hasRecordingStudioAccess);

  const save = async (nextX, nextRs) => {
    if (!nextX && !nextRs) {
      toast.error("User must retain access to at least one product");
      return;
    }
    setSaving(true);
    try {
      await api.updateUserProductAccess(user.id, {
        hasOctopushXAccess: nextX,
        hasRecordingStudioAccess: nextRs,
      });
      toast.success("Access updated");
      onChanged?.();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to update access");
      // revert
      setX(!!user.hasOctopushXAccess);
      setRs(!!user.hasRecordingStudioAccess);
    } finally {
      setSaving(false);
    }
  };

  const toggleX = () => {
    const next = !x;
    setX(next);
    save(next, rs);
  };
  const toggleRs = () => {
    const next = !rs;
    setRs(next);
    save(x, next);
  };

  return (
    <div className="flex items-center gap-2">
      {companyHasOctopushX && (
        <button
          disabled={saving}
          onClick={toggleX}
          title="Octopush X access"
          className={`px-2 py-1 rounded-md text-[10px] font-semibold uppercase tracking-wider border transition-colors ${
            x
              ? "bg-purple-600/20 text-purple-300 border-purple-700"
              : "bg-gray-800 text-gray-500 border-gray-700 hover:text-gray-300"
          }`}
        >
          X
        </button>
      )}
      {companyHasRecordingStudio && (
        <button
          disabled={saving}
          onClick={toggleRs}
          title="Recording Studio access"
          className={`px-2 py-1 rounded-md text-[10px] font-semibold uppercase tracking-wider border transition-colors ${
            rs
              ? "bg-emerald-600/20 text-emerald-300 border-emerald-700"
              : "bg-gray-800 text-gray-500 border-gray-700 hover:text-gray-300"
          }`}
        >
          Studio
        </button>
      )}
    </div>
  );
}
